/*
 * Copyright 2025 Intuition Robotics ltd
 */
import {BaseComponent} from "@intuitionrobotics/thunderstorm/frontend";
import * as React from "react";
import {useContext} from "react";
import {DB_Patient} from "@app/app-shared/patient";
import {OnRemindersActions, RemindersModule} from "@modules/RemindersModule";
import {Card} from "../../widget/Card";
import {MedicationBadge} from "./MedicationBadge";
import {Spacing} from "@res/styles/styles";
import {VGap} from "../../widget/VGap";
import {AddMedicationReminderButton} from "./AddMedicationReminderButton";
import {FONTS} from "@res/fonts";
import {COLORS} from "@res/colors";
import {HLine} from "../../widget/HLine";
import {generateHex} from "@intuitionrobotics/ts-common";
import {ContactsContext, ContactsMap} from "../messages/ContactsContext";
import {OrganizationMap, OrganizationsContext} from "../organizations/OrganizationsContext";

type Props = {
	patient: DB_Patient;
}

type PropsForClassComponent = {
	patient: DB_Patient;
	organizations: OrganizationMap;
	contacts: ContactsMap
}
export const MedicationReminderInfoWrapper= (props: Props) => {
	const {organizations} = useContext(OrganizationsContext);
	const {contacts} = useContext(ContactsContext);

	return <MedicationReminderInfoWrapperClass patient={props.patient} organizations={organizations} contacts={contacts}/>
}

export class MedicationReminderInfoWrapperClass
	extends BaseComponent<PropsForClassComponent>
	implements OnRemindersActions {

	constructor(props: PropsForClassComponent) {
		super(props);
	}

	__onRemindersQueried = () => {
		this.forceUpdate();
	}

	render() {
		const reminders = RemindersModule.filterOnlyCcReminder(this.props.contacts,
			this.props.organizations[this.props.patient.organizationId], RemindersModule.getReminders(this.props.patient._id));

		if (!reminders)
			return <div>
				<div className={`loader`}/>
				<div style={{marginTop: '20px', color: '#f9f9f9'}}>{"Loading..."}</div>
			</div>

		if (reminders.length === 0)
			return <div className={`ll_v_s`}>
				{FONTS.reg_18("Medication Reminders")}
				<div className={`ll_v_c`} style={{
					minHeight: "290px",
					justifyContent: "center",
					border: `1px dashed ${COLORS.neutral_gray_4}`
				}}>
					<AddMedicationReminderButton patient={this.props.patient}/>
				</div>
			</div>

		return (
			<div className={`ll_v_s`} style={{paddingBottom: 20, marginTop: 20}}>
				<div className={`ll_h_c`} style={{height: "1.2em"}}>
					{FONTS.reg_18("Medication Reminders")}
				</div>
				<VGap v={Spacing.m}/>
				<Card
					style={{
						overflowY: "auto",
						maxHeight: "380px",
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
						backgroundColor: 'white'
					}}>
					{reminders.map(
						(reminder) => {
							return (
								<div style={{width: "90%"}} key={generateHex(8)}>
									<MedicationBadge key={reminder.id} patient={this.props.patient} reminder={reminder}/>
									<HLine style={{backgroundColor: COLORS.color_gray_medium}}/>
								</div>
							)
						})
					}
				</Card>
			</div>
		);
	}
}
